var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowBarRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6934 7.70711C13.3029 7.31658 13.3029 6.68342 13.6934 6.29289C14.084 5.90237 14.7171 5.90237 15.1076 6.29289L19.4005 10.5858C20.1816 11.3668 20.1816 12.6332 19.4005 13.4142L15.1076 17.7071C14.7171 18.0976 14.084 18.0976 13.6934 17.7071C13.3029 17.3166 13.3029 16.6834 13.6934 16.2929L16.9863 13H10.0005C9.44817 13 9.00046 12.5523 9.00046 12C9.00046 11.4477 9.44817 11 10.0005 11H16.9863L13.6934 7.70711Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C6.55228 3 7 3.44772 7 4V20C7 20.5523 6.55228 21 6 21C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowBarRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArrowBarRight.912cf4df149b985170dcedab5caad5b8.svg";